function downScreen() {
    const downComponent = document.querySelectorAll('.js-down');
    if (downComponent) {
        downComponent.forEach((item) => {
            item.addEventListener('click', (event) => {
                const { target } = event;
                console.log('click', target instanceof Element);
                if (target instanceof Element) {
                    const downContainer = target.closest('.js-down-container');
                    if (downContainer instanceof HTMLElement) {
                        console.log(downContainer.offsetTop + downContainer.clientHeight);
                        window.scrollTo({
                            top: downContainer.offsetTop + downContainer.clientHeight,
                            behavior: 'smooth',
                        });
                    }
                }
            });
        });
    }
}
export default downScreen;
